import React from 'react';
import PropTypes from 'prop-types';

const Overlay = ({ children, render, theme }) =>
  render && <div className={theme.overlay}>{children}</div>;

export default Overlay;

Overlay.defaultProps = {
  children: null,
  render: true,
  theme: {},
};

Overlay.propTypes = {
  children: PropTypes.node,
  render: PropTypes.bool,
  theme: PropTypes.shape({}),
};
